import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./simphony_information_line_field.js";
//#region src/simphony_information_line_field_helper.ts
var simphony_information_line_field_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(simphonyInformationLineField) {
	switch (simphonyInformationLineField) {
		case "guest-name": return "Guest Name";
		case "guest-phone-number": return "Guest Phone Number";
		case "guest-email": return "Guest Email";
		case "outpost-name": return "Outpost Name";
		case "table-number": return "Table Number";
	}
}
//#endregion
export { name, simphony_information_line_field_helper_exports };

//# sourceMappingURL=simphony_information_line_field_helper.js.map